var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1690725386185,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6474,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.866667 593.066667l279.466666-162.133334c42.666667-25.6 98.133333 6.4 87.466667 55.466667V810.666667c10.666667 51.2-42.666667 81.066667-87.466667 55.466666L93.866667 706.133333c-44.8-25.6-44.8-87.466667 0-113.066666z",
    fill: "#11b4da",
    "p-id": 6475
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M917.333333 601.6c76.8-123.733333 49.066667-251.733333-27.733333-330.666667-44.8-44.8-108.8-74.666667-177.066667-74.666666h-194.133333c-32 0-57.6 25.6-57.6 57.6 0 29.866667 25.6 55.466667 55.466667 55.466666h189.866666c38.4 0 72.533333 14.933333 98.133334 40.533334 46.933333 46.933333 61.866667 130.133333 0 202.666666-17.066667 19.2-53.333333 36.266667-78.933334 36.266667H458.666667v110.933333h275.2c74.666667 0 145.066667-36.266667 183.466666-98.133333z",
    fill: "#11b4da",
    "p-id": 6476
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.326710091116d64c8eba49ee2d7ee8fd.svg";
export { ForwardRef as ReactComponent };